import type {StringSchema} from 'yup';
import {string, addMethod} from 'yup';

// Add custom validators to yup
addMethod<StringSchema>(
	string,
	'noTrailingWhiteSpaces',
	function (this: StringSchema, message: string) {
		return this.test('noTrailingWhiteSpaces', message, function (value) {
			return typeof value !== 'string' || value.length === value.trim().length;
		});
	},
);
addMethod<StringSchema>(
	string,
	'hasSpecialCharacters',
	function (this: StringSchema, message: string) {
		return this.test('hasSpecialCharacters', message, function (value = '') {
			return !(
				/[\u2000-\u2BFF]/.test(value) || /[\u{10000}-\u{10FFFF}]/u.test(value)
			);
		});
	},
);
